/**
 * Salt prefixed to a staff PIN before hashing. MUST stay byte-for-byte
 * identical to `_pinSalt` in
 * apps/terminal/lib/data/repositories/staff_repository.dart — the terminal
 * and admin compute the same `pinHash` for the same PIN.
 */
export const STAFF_PIN_SALT = "cpos_freepay_staff_pin_v1";

/**
 * Hash a 4-digit staff PIN as lowercase-hex SHA-256 of
 * `"<salt>:<pin>"`. Faithful port of the terminal's `StaffRepository.hashPin`.
 * Uses WebCrypto so it runs in the browser (admin) and Node 22 (tests).
 */
export async function hashStaffPin(pin: string): Promise<string> {
  const data = new TextEncoder().encode(`${STAFF_PIN_SALT}:${pin}`);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
